import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  // Super Category
  superCategoryList: [],
  superCategoryListLoading: false,
  superCategoryPaginationData: {},
  superCategoryDetails: {},
  superCategoryDetailsLoading: false,
  updateSuperCategory: false,
  // Category
  categoryList: [],
  categoryListLoading: false,
  categoryPaginationData: {},
  categoryDetails: {},
  categoryDetailsLoading: false,
  updateCategory: false,

  // Sub Category
  subCategoryList: [],
  subCategoryListLoading: false,
  subCategoryPaginationData: {},
  subCategoryDetails: {},
  subCategoryDetailsLoading: false,
  updateSubCategory: false,

  // Brand
  brandList: [],
  brandListLoading: false,
  brandPaginationData: {},
  brandDetails: {},
  brandDetailsLoading: false,
  updateBrand: false,

  // Product
  productList: [],
  productListLoading: false,
  productPaginationData: {},
  productDetails: {},
  productDetailsLoading: false,

  modalOpen: false,
  ApiError: '',
}

const marketplaceSlice = createSlice({
  name: 'marketplace',
  initialState,
  reducers: {
    // Super Category Actions
    getSuperCategoryListRequest: (state) => {
      state.superCategoryListLoading = true
    },
    getSuperCategoryListSuccess: (state, { payload }) => {
      state.superCategoryListLoading = false
      state.superCategoryList = payload?.data
      state.superCategoryPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getSuperCategoryListFailed: (state, { payload }) => {
      state.superCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    getSuperCategoryDetailsRequest: (state) => {
      state.superCategoryDetailsLoading = true
    },
    getSuperCategoryDetailsSuccess: (state, { payload }) => {
      state.superCategoryDetails = payload?.data
      state.superCategoryDetailsLoading = false
    },
    getSuperCategoryDetailsFailed: (state, { payload }) => {
      state.superCategoryDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    addSuperCategoryRequest: (state) => {
      state.superCategoryListLoading = true
      state.updateSuperCategory = false
      state.modalOpen = false
    },
    addSuperCategorySuccess: (state, { payload }) => {
      state.updateSuperCategory = true
      state.modalOpen = true
      state.ApiError = payload
      state.superCategoryListLoading = false
    },
    addSuperCategoryFailed: (state, { payload }) => {
      state.updateSuperCategory = false
      state.superCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    updateSuperCategoryRequest: (state) => {
      state.updateSuperCategory = false
      state.superCategoryListLoading = true
    },
    updateSuperCategorySuccess: (state, { payload }) => {
      state.updateSuperCategory = true
      state.superCategoryListLoading = false
      state.modalOpen = true
      state.ApiError = payload
    },
    updateSuperCategoryFailed: (state, { payload }) => {
      state.updateSuperCategory = false
      alert(JSON.stringify(payload, null, 2))
      state.superCategoryListLoading = false
    },

    activeInactiveSuperCategoryRequest: (state) => {
      state.updateSuperCategory = false
      state.superCategoryListLoading = true
    },
    activeInactiveSuperCategorySuccess: (state, { payload }) => {
      state.updateSuperCategory = true
      state.modalOpen = true
      state.superCategoryListLoading = false
      state.ApiError = payload
    },
    activeInactiveSuperCategoryFailed: (state) => {
      state.updateSuperCategory = false
      state.superCategoryListLoading = false
    },

    deleteSuperCategoryRequest: (state) => {
      state.updateSuperCategory = false
      state.superCategoryListLoading = true
    },
    deleteSuperCategorySuccess: (state, { payload }) => {
      state.updateSuperCategory = true
      state.superCategoryListLoading = false
      state.modalOpen = true
      state.ApiError = payload
    },
    deleteSuperCategoryFailed: (state) => {
      state.updateSuperCategory = false
    },
    // Category Actions
    getCategoryListRequest: (state) => {
      state.categoryListLoading = true
    },
    getCategoryListSuccess: (state, { payload }) => {
      state.categoryListLoading = false
      state.categoryList = payload?.data
      state.categoryPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getCategoryListFailed: (state, { payload }) => {
      state.categoryListLoading = false
    },

    getCategoryDetailsRequest: (state) => {
      state.categoryDetailsLoading = true
    },
    getCategoryDetailsSuccess: (state, { payload }) => {
      state.categoryDetails = payload?.data
      state.categoryDetailsLoading = false
    },
    getCategoryDetailsFailed: (state) => {
      state.categoryDetailsLoading = false
    },

    addCategoryRequest: (state) => {
      state.categoryListLoading = true
      state.updateCategory = false
      state.modalOpen = false
    },
    addCategorySuccess: (state, { payload }) => {
      state.updateCategory = true
      state.modalOpen = true
      state.ApiError = payload
      state.categoryListLoading = false
    },
    addCategoryFailed: (state, { payload }) => {
      state.updateCategory = false
      state.categoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    updateCategoryRequest: (state) => {
      state.updateCategory = false
    },
    updateCategorySuccess: (state, { payload }) => {
      state.updateCategory = true
      state.modalOpen = true
      state.ApiError = payload
    },
    updateCategoryFailed: (state) => {
      state.updateCategory = false
    },

    deleteCategoryRequest: (state) => {
      state.updateCategory = false
    },
    deleteCategorySuccess: (state, { payload }) => {
      state.updateCategory = true
      state.modalOpen = true
      state.ApiError = payload
    },
    deleteCategoryFailed: (state) => {
      state.updateCategory = false
    },

    // Sub Category Actions
    getSubcategoryListRequest: (state) => {
      state.subCategoryListLoading = true
    },
    getSubcategoryListSuccess: (state, { payload }) => {
      state.subCategoryListLoading = false
      state.subCategoryList = payload?.data
      state.subCategoryPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getSubcategoryListFailed: (state) => {
      state.subCategoryListLoading = false
    },

    getSubcategoryDetailsRequest: (state) => {
      state.subCategoryDetailsLoading = true
    },
    getSubcategoryDetailsSuccess: (state, { payload }) => {
      state.subCategoryDetails = payload?.data
      state.subCategoryDetailsLoading = false
    },
    getSubcategoryDetailsFailed: (state) => {
      state.subCategoryDetailsLoading = false
    },

    addSubcategoryRequest: (state) => {
      state.subCategoryListLoading = true
      state.updateSubCategory = false
      state.modalOpen = false
    },
    addSubcategorySuccess: (state, { payload }) => {
      state.updateSubCategory = true
      state.modalOpen = true
      state.ApiError = payload
      state.subCategoryListLoading = false
    },
    addSubcategoryFailed: (state, { payload }) => {
      state.updateSubCategory = false
      state.subCategoryListLoading = false
    },

    updateSubcategoryRequest: (state) => {
      state.updateSubCategory = false
    },
    updateSubcategorySuccess: (state, { payload }) => {
      state.updateSubCategory = true
      state.modalOpen = true
      state.ApiError = payload
    },
    updateSubcategoryFailed: (state) => {
      state.updateSubCategory = false
    },

    deleteSubcategoryRequest: (state) => {
      state.updateSubCategory = false
    },
    deleteSubcategorySuccess: (state, { payload }) => {
      state.updateSubCategory = true
      state.modalOpen = true
      state.ApiError = payload
    },
    deleteSubcategoryFailed: (state) => {
      state.updateSubCategory = false
    },

    // Brand Actions
    getBrandListRequest: (state) => {
      state.brandListLoading = true
    },
    getBrandListSuccess: (state, { payload }) => {
      state.brandListLoading = false
      state.brandList = payload?.data
      state.brandPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getBrandListFailed: (state) => {
      state.brandListLoading = false
    },

    getBrandDetailsRequest: (state) => {
      state.brandDetailsLoading = true
    },
    getBrandDetailsSuccess: (state, { payload }) => {
      state.brandDetails = payload?.data
      state.brandDetailsLoading = false
    },
    getBrandDetailsFailed: (state) => {
      state.brandDetailsLoading = false
    },

    addBrandRequest: (state) => {
      state.brandListLoading = true
      state.updateBrand = false
      state.modalOpen = false
    },
    addBrandSuccess: (state, { payload }) => {
      state.updateBrand = true
      state.modalOpen = true
      state.ApiError = payload
      state.brandListLoading = false
    },
    addBrandFailed: (state, { payload }) => {
      state.updateBrand = false
      state.brandListLoading = false
    },

    updateBrandRequest: (state) => {
      state.updateBrand = false
    },
    updateBrandSuccess: (state, { payload }) => {
      state.updateBrand = true
      state.modalOpen = true
      state.ApiError = payload
    },
    updateBrandFailed: (state) => {
      state.updateBrand = false
    },

    deleteBrandRequest: (state) => {
      state.updateBrand = false
    },
    deleteBrandSuccess: (state, { payload }) => {
      state.updateBrand = true
      state.modalOpen = true
      state.ApiError = payload
    },
    deleteBrandFailed: (state) => {
      state.updateBrand = false
    },

    // Product Actions

    getProductListRequest: (state) => {
      state.productListLoading = true
    },
    getProductListSuccess: (state, { payload }) => {
      state.productListLoading = false
      state.productList = payload?.data
      state.productPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getProductListFailed: (state, { payload }) => {
      state.productListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    getProductDetailsRequest: (state) => {
      state.productDetailsLoading = true
    },
    getProductDetailsSuccess: (state, { payload }) => {
      state.productDetails = payload?.data
      state.productDetailsLoading = false
    },
    getProductDetailsFailed: (state, { payload }) => {
      state.productDetailsLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    resetMarketplaceError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },
  },
})

export const {
  // super category
  getSuperCategoryListRequest,
  getSuperCategoryListSuccess,
  getSuperCategoryListFailed,
  getSuperCategoryDetailsRequest,
  getSuperCategoryDetailsSuccess,
  getSuperCategoryDetailsFailed,
  addSuperCategoryRequest,
  addSuperCategorySuccess,
  addSuperCategoryFailed,
  updateSuperCategoryRequest,
  updateSuperCategorySuccess,
  updateSuperCategoryFailed,
  activeInactiveSuperCategoryRequest,
  activeInactiveSuperCategorySuccess,
  activeInactiveSuperCategoryFailed,
  // Category
  getCategoryListRequest,
  getCategoryListSuccess,
  getCategoryListFailed,
  getCategoryDetailsRequest,
  getCategoryDetailsSuccess,
  getCategoryDetailsFailed,
  addCategoryRequest,
  addCategorySuccess,
  addCategoryFailed,
  updateCategoryRequest,
  updateCategorySuccess,
  updateCategoryFailed,
  deleteCategoryRequest,
  deleteCategorySuccess,
  deleteCategoryFailed,

  // Sub Category
  getSubcategoryListRequest,
  getSubcategoryListSuccess,
  getSubcategoryListFailed,
  getSubcategoryDetailsRequest,
  getSubcategoryDetailsSuccess,
  getSubcategoryDetailsFailed,
  addSubcategoryRequest,
  addSubcategorySuccess,
  addSubcategoryFailed,
  updateSubcategoryRequest,
  updateSubcategorySuccess,
  updateSubcategoryFailed,
  deleteSubcategoryRequest,
  deleteSubcategorySuccess,
  deleteSubcategoryFailed,

  // Brand
  getBrandListRequest,
  getBrandListSuccess,
  getBrandListFailed,
  getBrandDetailsRequest,
  getBrandDetailsSuccess,
  getBrandDetailsFailed,
  addBrandRequest,
  addBrandSuccess,
  addBrandFailed,
  updateBrandRequest,
  updateBrandSuccess,
  updateBrandFailed,
  deleteBrandRequest,
  deleteBrandSuccess,
  deleteBrandFailed,
  getProductListRequest,
  getProductListSuccess,
  getProductListFailed,
  getProductDetailsRequest,
  getProductDetailsSuccess,
  getProductDetailsFailed,
  deleteSuperCategoryRequest,
  deleteSuperCategorySuccess,
  deleteSuperCategoryFailed,

  resetMarketplaceError,
} = marketplaceSlice.actions

export default marketplaceSlice.reducer
